import { render, staticRenderFns } from "./DocumentTitle.vue?vue&type=template&id=1fbc215a"
import script from "./DocumentTitle.vue?vue&type=script&lang=js"
export * from "./DocumentTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports